export function stringToHue(string) {
    let hash = 0;

    for (let i = 0; i < string.length; i++) {
       hash = (string.charCodeAt(i) + hash * 31) >> 0;
    }

    return hash & 0xFF;
}
